import { render, staticRenderFns } from "./CoproprieteAccordion.vue?vue&type=template&id=41fae7a7"
import script from "./CoproprieteAccordion.vue?vue&type=script&lang=ts"
export * from "./CoproprieteAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports